<template>
  <div class="confirm">
    <div v-if="content"
         v-html="content"
         class="--margin-bottom"></div>
    <template v-if="!isPrebooking && mover">
      <div class="--margin-bottom"
           v-html="stepConfigOptions && $t(stepConfigOptions.descriptionMover)"></div>
      <card-flex class="confirm__mover"
                 no-box-shadow
                 mobile-wrapper-column
                 :image="mover.logo_url">
        <div class="confirm__mover__infos">
          <div class="--margin-right">
            {{$t('confirm.mover.refClient', {refClient: mover.num_client})}}
            <br>
            {{$t('confirm.mover.society', {society: mover.name})}}
          </div>
          <div>
            {{$t('confirm.mover.telephone', {telephone: mover.phone_office})}}
            <br>
            {{$t('confirm.mover.email', {email: mover.email})}}
          </div>
        </div>
      </card-flex>
      <div class="--margin-bottom"
           v-html="stepConfigOptions && $t(stepConfigOptions.bottomDescription)"></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CardFlex from '@/utils/components/CardFlex.vue';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'confirm',
  extends: MoveManager,
  components: {
    CardFlex,
  },
  computed: {
    ...mapGetters({
      comparatorConfig: 'configStore/comparatorConfig',
      isPrebooking: 'configStore/isPrebooking',
    }),
    mover() {
      return this.offer && {
        ...this.offer.mover,
        ...this.offer.contact,
      };
    },
    content() {
      return this.getTextVersion((this.stepConfig && this.stepConfig.content), {
        mover: this.mover && this.mover.name,
        n2: this.demand.n2,
      });
    },
    stepConfig() {
      return this.comparatorConfig.confirm;
    },
    stepConfigOptions() {
      return this.stepConfig && this.stepConfig.options;
    },
  },
};
</script>

<style scoped lang="scss">
.confirm {
  .--margin-right {
    margin-right: 40px;
  }
  .--margin-bottom {
    margin-bottom: 20px;
  }
  &__mover {

    &__infos {
      @include breakpoint(mobile) {
        display: flex;
      }
    }

    :deep(.card-flex__img) {
      height: 70px;
    }
  }
}
</style>
